import React from 'react';
import SectionField from './SectionField';
import SectionFieldDocument from './SectionFieldDocument';
import SectionFieldPrescription from './SectionFieldPrescription';

const Section = (props) => {
  const {
    id,
    name,
    type,
    fields = [],
    documents = [],
    prescriptions = []
  } = props;

  const showFieldMedicalRecord = (c) => {
    return (
      c.answer ||
      c.attachments.length > 0 ||
      c.options.filter((c) => c.isChecked)?.length > 0
    );
  };

  const render = () => {
    if (type === 'medicalRecord') {
      return fields
        .filter(showFieldMedicalRecord)
        .map((values) => <SectionField key={values.id} {...values} />);
    }

    if (type === 'document') {
      return documents.map((c) => <SectionFieldDocument key={c.id} {...c} />);
    }

    if (type === 'prescription') {
      return prescriptions.map((c) => (
        <SectionFieldPrescription key={c.id} {...c} />
      ));
    }

    return null;
  };

  if (type === 'medicalRecord' && !fields.some(showFieldMedicalRecord)) {
    return null;
  }

  if (type === 'document' && documents.length === 0) {
    return null;
  }

  if (type === 'prescription' && prescriptions.length === 0) {
    return null;
  }

  if (type === 'comments') {
    return null;
  }

  return (
    <div key={id} className="gx-attendance-section gx-mb-3">
      <div className="gx-attendance-section-item-title">
        <span>{name}</span>
      </div>
      <div className="gx-m-3">{render()}</div>
    </div>
  );
};

export default Section;
